import React from "react";

// --- NEW COMPONENT: Floating Logo Wall (Contained & Transparent) ---
const IntegrationsBanner = () => {
  // Styles for the marquee animation
  const marqueeStyle = {
    display: "flex",
    width: "max-content",
    animation: "marquee 60s linear infinite",
  };

  const marqueeReverseStyle = {
    display: "flex",
    width: "max-content",
    animation: "marqueeReverse 60s linear infinite",
  };

  return (
    // UPDATED: Added full width gray background and changed margins to padding
    <div className="w-full py-20 border-t border-gray-400">
      <div className="w-full max-w-7xl mx-auto px-4">
        <div className="relative w-full overflow-hidden bg-transparent group">
          <style>{`
            @keyframes marquee {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
            @keyframes marqueeReverse {
              0% { transform: translateX(-50%); }
              100% { transform: translateX(0); }
            }
            .mask-gradient {
              mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
              -webkit-mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
            }
          `}</style>

          <div className="relative z-20 text-center max-w-3xl mx-auto px-4 mb-12">
            {/* UPDATED: Removed 'tracking-tight', added 'not-italic', changed to 'font-semibold' for a simpler look */}
            <h2 className="text-3xl md:text-3xl font-semibold text-gray-900 mb-6 not-italic">
              Secure Your Data+Users Everywhere
            </h2>
            <p className="text-gray-600 text-sm md:text-sm non-italic">
              With 1000s of pre-built integrations across hybrid multicloud and
              SaaS
            </p>
          </div>

          <div className="flex flex-col gap-6 mask-gradient">
            {/* ROW 1 */}
            <div className="w-full overflow-hidden">
              <div style={marqueeStyle}>
                {[...Array(4)].map((_, i) => (
                  <img
                    key={i}
                    src="https://res.cloudinary.com/dpn3bkjba/image/upload/v1764852824/sass-group-one_ztrkcs.svg"
                    alt="SaaS Integrations Group 1"
                    // UPDATED: Reduced height to h-12 md:h-16 and margin to mx-4
                    className="h-12 md:h-16 mx-4 flex-shrink-0 max-w-none opacity-90 hover:opacity-100 transition-opacity"
                  />
                ))}
              </div>
            </div>
            {/* ROW 2 */}
            <div className="w-full overflow-hidden">
              <div style={marqueeReverseStyle}>
                {[...Array(4)].map((_, i) => (
                  <img
                    key={i}
                    src="https://res.cloudinary.com/dpn3bkjba/image/upload/v1764852824/sass-group-two_p6xxs7.svg"
                    alt="SaaS Integrations Group 2"
                    // UPDATED: Reduced height to h-12 md:h-16 and margin to mx-4
                    className="h-12 md:h-16 mx-4 flex-shrink-0 max-w-none opacity-90 hover:opacity-100 transition-opacity"
                  />
                ))}
              </div>
            </div>
            {/* ROW 3 */}
            <div className="w-full overflow-hidden">
              <div style={marqueeStyle}>
                {[...Array(4)].map((_, i) => (
                  <img
                    key={i}
                    src="https://res.cloudinary.com/dpn3bkjba/image/upload/v1764852825/llm-group-one_atusht.svg"
                    alt="LLM Integrations"
                    // UPDATED: Reduced height to h-12 md:h-16 and margin to mx-4
                    className="h-12 md:h-16 mx-4 flex-shrink-0 max-w-none opacity-90 hover:opacity-100 transition-opacity"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// --- SHARED STYLE: Light Green Background, White Icon ---
// Color: #10b981 (Emerald 500)

// 1. Application Security Logo
const AppSecLogo = (
  <div className="w-16 h-16 bg-green-900 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <path d="M12 8v4" />
      <path d="M12 16h.01" />
    </svg>
  </div>
);

// 2. Web Security Logo
const WebSecLogo = (
  <div className="w-16 h-16 bg-green-900 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="2" y1="12" x2="22" y2="12"></line>
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
    </svg>
  </div>
);

// 3. Data Security Logo
const DataSecLogo = (
  <div className="w-16 h-16 bg-green-900 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
      <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path>
      <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
    </svg>
  </div>
);

// 4. Endpoint/IoT Security Logo
const EndpointLogo = (
  <div className="w-16 h-16 bg-green-900 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
      <line x1="8" y1="21" x2="16" y2="21"></line>
      <line x1="12" y1="17" x2="12" y2="21"></line>
    </svg>
  </div>
);

// 5. Email Security Logo
const EmailLogo = (
  <div className="w-16 h-16 bg-green-900 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
      <polyline points="22,6 12,13 2,6"></polyline>
    </svg>
  </div>
);

// 6. Identity Security Logo
const IdentityLogo = (
  <div className="w-16 h-16 bg-green-900 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </svg>
  </div>
);

// 7. Network Security Logo
const NetworkLogo = (
  <div className="w-16 h-16 bg-green-900 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
      <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
      <line x1="6" y1="6" x2="6" y2="6"></line>
      <line x1="6" y1="18" x2="6" y2="18"></line>
    </svg>
  </div>
);

export const enterpriseFeatures = [
  {
    id: "ApplicationSecurity",
    title: "Application Security",
    icon: AppSecLogo,
    heading: "See the applications. Control the risk. Protect the business.",
    points: [
      "Discover and map every app in your ecosystem.",
      "Control applications with fine-grained policies, not blunt blocks.",
      "Protect SaaS data with full DLP and threat defense.",
      "Secure private apps with Zero Trust access.",
    ],
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1771749291/application_s_ps2ccu.png",

    detailHeading: "Application Security",
    detailIntro: [
      "Applications now span SaaS platforms, cloud services, and internal systems creating blind spots, inconsistent controls, and new paths for attackers to exploit. As software grows more complex, even a single vulnerability can expose data, disrupt operations, or break customer trust.",
      "Synthera Security protects your entire application ecosystem with modern, Zero Trust–driven controls. We discover every app, enforce granular usage policies, safeguard data flowing into SaaS, and secure private applications with ZTNA. With complete visibility across all your apps cloud, on prem, and custom we help you reduce risk without slowing your teams down.",
    ],
    detailConclusion: <IntegrationsBanner />,
    cards: [
      {
        emoji: "🔍",
        title: "Application Discovery & Visibility",
        description:
          "Deep discovery across your environments to map every application, user, and access path",
        stat: "Identify 100% of applications in 48 hours",
      },
      {
        emoji: "🔐",
        title: "Intelligent Access with Modern CASB",
        description:
          "Enable productivity while managing risk with granular, behavior driven CASB policies",
        stat: "Reduce risky SaaS behaviors by 60%",
      },
      {
        emoji: "🛡️",
        title: "Zero Trust Network Access (ZTNA)",
        description:
          "Replace vulnerable VPNs with continuous, identity verified access to internal applications",
        stat: "Cut unauthorized access incidents by 85%",
      },
      {
        emoji: "🧱",
        title: "Data Loss Prevention & Threat Defense",
        description:
          "Real-time DLP and threat blocking to prevent leaks, ransomware, and exploit attempts",
        stat: "Stop 99% of applicationlayer attacks before impact",
      },
    ],
    // extraSections: [
    //   {
    //     title: "Application Discovery & Visibility",
    //     description:
    //       "Gain continuous visibility into every application across your environment—whether SaaS, private, custom-built, or shadow IT. Get a comprehensive inventory detailing what’s running and where, ensuring nothing remains unseen.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1764690498/app_discovery_hgx5la.png",
    //   },
    //   {
    //     title: "Intelligent Access with Modern CASB",
    //     description:
    //       "Enable smart, adaptive access to all your SaaS, private, and web applications. Enforce real-time granular control that prevent risky behavior and protect sensitive data—delivering security without compromising user experience.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1764690498/Intelligent_Access_with_Modern_CASB_yuaaoe.png",
    //   },
    //   {
    //     title: "Zero Trust Network Access (ZTNA)",
    //     description:
    //       "Replace brittle VPNs with continuous, identity-verified access to internal and private applications—ensuring only validated users and devices reach what they’re meant to, nothing more.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1764690498/Zero_Trust_Network_Access_ZTNA_qo2sh3.png",
    //   },
    //   {
    //     title: "Data Loss Prevention & Threat Defense",
    //     description:
    //       "Enforce real-time DLP and intelligent threat protection to prevent data exposure, ransomware, and exploit attempts across your entire application ecosystem.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1764690498/Data_Loss_Prevention_Threat_Defense_cp1mp3.png",
    //   },
    // ],
  },

  {
    id: "WebSecurity",
    title: "Web Security",
    icon: WebSecLogo,
    heading: "Browse freely. Block threats. Stay protected.",
    points: [
      "Enforce safe browsing with precise, flexible policies.",
      "Block phishing, AI-driven exploits, HEAT attacks, and zero-days.",
      "Isolate risky sites with Zero Trust browser isolation.",
      "Secure every user, device, and session with cloud-native modern SWG.",
    ],
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1771749291/web_s_cgqnmc.png",
    detailHeading: "Web Security",
    detailIntro: [
      "The web has become the front door to every business and the first target for modern attackers. With phishing, AI-driven exploits, HEAT techniques, and zero-day threats accelerating faster than traditional defenses can respond, users are only one click away from compromise. As work becomes fully digital and remote, enterprises need web protection that keeps pace without slowing people down.",
      "Synthera Security delivers next-generation Web Security that protects every browsing session, on any device, from any location. Our platform combines a powerful Secure Web Gateway, advanced DLP, Browser Security, and Zero Trust remote isolation to stop threats before they reach users. With intelligent, seamless protection built into every connection, your teams stay secure, productive, and confident wherever they work.",
    ],
    detailConclusion: <IntegrationsBanner />,
    cards: [
      {
        emoji: "🌐",
        title: "Secure Web Gateway (SWG)",
        description:
          "Gain total control over all web traffic to block malicious, non-compliant, or risky activities at the edge",
        stat: "Prevent 99% of web-based phishing and malware",
      },
      {
        emoji: "🗂️",
        title: "Data Loss Prevention (DLP) for the Web",
        description:
          "Prevent both accidental and intentional exposure of confidential data via websites, webmail, and SaaS workflows",
        stat: "Reduce web-driven data leaks by 90%",
      },
      {
        emoji: "🚨",
        title: "Advanced Browser & Threat Protection",
        description:
          "Deploy intelligent defenses that intercept evasive threats, isolate risky sites, and defeat emerging browser exploits",
        stat: "Eliminate zero-day payloads with 99.7% accuracy",
      },
      {
        emoji: "🧊",
        title: "Zero Trust Remote Isolation",
        description:
          "Run all unknown web content in secure remote containers to ensure threats never reach endpoints",
        stat: "Block 100% of drive-by infections and targeted exploit attempts",
      },
    ],
    // extraSections: [
    //   {
    //     title: "Intelligent Access with Modern SWG",
    //     description:
    //       "Enforce precise, real-time control over all web traffic—blocking malicious, non-compliant, and risky activity at the edge while keeping users protected anywhere they connect.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1764585984/appication_secu_svrprp.webp",
    //   },
    //   {
    //     title: "Remote Browser Isolation (RBI)",
    //     description:
    //       "Execute unknown or risky web content in secure, remote containers—so threats are isolated in the cloud and never reach user endpoints.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Data Loss Prevention (DLP) for the Web",
    //     description:
    //       "Stop accidental and intentional data exposure across websites, webmail, and SaaS browser workflows—protecting sensitive information without disrupting how users work.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Advanced Browser & Threat Protection",
    //     description:
    //       "Deploy intelligent defenses that intercept evasive threats, isolate risky sites, and stop emerging browser exploits—protecting users before attacks ever reach their devices.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    // ],
  },

  {
    id: "DataSecurity",
    title: "Data Security",
    icon: DataSecLogo,
    heading: "Know your data. Control its movement. Prevent loss.",
    points: [
      "Discover and classify sensitive data everywhere with DSPM.",
      "Protect data in motion and at rest with unified DLP.",
      "Stop data loss with insider risk and threat detection.",
      "Enforce Zero Trust on every data access and movement.",
      "Track and govern data flows across apps, users, and clouds.",
    ],
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1771749290/data_s_mhoddf.png",
    detailHeading: "Data Security",
    detailIntro: [
      "Data now moves faster and farther than ever across SaaS apps, cloud services, devices, and AI models. But as information spreads, so do the risks: accidental exposure, insider threats, shadow data, misconfigurations, and advanced attacks targeting sensitive files. Without unified visibility and control, enterprises struggle to protect what matters most.",
      "Synthera Security delivers modern Data Security built for a cloud-first, AI-driven world. We classify and protect data everywhere it lives and moves, enforce realtime DLP policies across SaaS and web, secure sensitive content inside AI tools, and detect threats before they become incidents. With full visibility and consistent controls across your entire data estate, Synthera helps you safeguard your information without slowing innovation.",
    ],
    detailConclusion: <IntegrationsBanner />,
    cards: [
      {
        emoji: "🧭",
        title: "Data Security Posture Management (DSPM)",
        description:
          "Continuously discover, classify, and assess sensitive data across cloud, SaaS, and databases to expose overexposure and hidden data risk.",
        stat: "Discover sensitive data across environments in minutes",
      },
      {
        emoji: "📄",
        title: "Modern Data Loss Prevention (DLP)",
        description:
          "Enforce consistent data protection policies across data in motion, at rest, and in use to prevent accidental leaks and intentional exfiltration.",
        stat: "Stop 95% of unauthorized data movement in real time",
      },
      {
        emoji: "🛡️",
        title: "Content Disarm & Reconstruction (CDR)",
        description:
          "Neutralize file-based threats by removing active content and delivering safe, reconstructed files—without relying on malware detection.",
        stat: "Neutralize 100% of file-borne threats at ingestion",
      },
      {
        emoji: "🤖",
        title: "Generative AI Data Security",
        description:
          "Detect and control sensitive data shared with generative AI tools and copilots to prevent leakage and misuse.",
        stat: "Block 98% of sensitive data exposure to AI tools in real time",
      },
      {
        emoji: "🎭",
        title: "Behavior Analytics for Insider Threats",
        description:
          "Baseline normal user and entity behavior to uncover insider risk, compromised accounts, and stealthy misuse before data is impacted.",
        stat: "Identify insider risk before data loss occurs",
      },
      {
        emoji: "🗄️",
        title: "Database Access Monitoring",
        description:
          "Gain deep visibility into database activity to detect unauthorized access, privilege abuse, and anomalous queries on crown-jewel data.",
        stat: "Detect risky database access in near real time",
      },
      {
        emoji: "⚖️",
        title: "Data Access Governance",
        description:
          "Enforce least-privilege access by continuously governing entitlements, removing excessive permissions, and reducing blast radius.",
        stat: "Reduce excessive access by up to 70% per review cycle",
      },
      {
        emoji: "🛑",
        title: "Data Detection & Response (DDR)",
        description:
          "Detect and stop sensitive data misuse, exfiltration, and insider-driven risk with real-time analytics across users, apps, and cloud.",
        stat: "Detect and contain 95% of data exfiltration attempts before impact",
      },
    ],
    // ★ UPDATED: Uses 'points' array instead of 'description' string ★
    // extraSections: [
    //   {
    //     title: "Data Security Posture Management (DSPM)",
    //     points: [
    //       "Continuously discover and classify sensitive data across cloud, SaaS, and databases.",
    //       "Map data exposure, toxic permission paths, and risk created by identities and AI usage.",
    //       "Prioritize remediation with real-time visibility into where data is most at risk.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Modern Data Loss Prevention (DLP)",
    //     points: [
    //       "Inspect and control sensitive data across email, web, SaaS, endpoints, and APIs.",
    //       "Apply contextual policies based on data type, user behavior, and destination.",
    //       "Stop data leakage in motion, at rest, and in use without disrupting productivity.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Content Disarm & Reconstruction (CDR)",
    //     points: [
    //       "Inspect inbound files and remove active content such as macros, scripts, and embedded objects.",
    //       "Reconstruct safe, usable documents without relying on signature or sandbox detection.",
    //       "Eliminate known and unknown file-borne threats before they reach users or data.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Generative AI Data Security",
    //     points: [
    //       "Monitor and control sensitive data shared with generative AI tools, copilots, and LLM-based applications.",
    //       "Prevent data leakage, unauthorized training, and prompt-based data exposure with policy-driven enforcement.",
    //       "Enforce Zero Trust controls and real-time visibility across AI prompts, outputs, and user interactions.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Behavior Analytics for Insider Threats",
    //     points: [
    //       "Analyze user and entity behavior to establish normal access and usage baselines.",
    //       "Identify deviations indicating insider risk, compromised credentials, or privilege abuse.",
    //       "Detect threats that bypass traditional controls using behavior-driven intelligence.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Database Access Monitoring",
    //     points: [
    //       "Monitor all database activity, including queries, admin actions, and privileged access.",
    //       "Detect anomalous behavior, credential misuse, and unauthorized data access in real time.",
    //       "Provide forensic-level audit trails for investigations, compliance, and breach response.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Data Access Governance",
    //     points: [
    //       "Continuously assess who has access to sensitive data and whether it is justified.",
    //       "Enforce least-privilege by removing excessive permissions and stale entitlements.",
    //       "Reduce blast radius and data exposure by aligning access with business intent.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Data Detection & Response (DDR)",
    //     points: [
    //       "Continuously detect sensitive data access, movement, and exfiltration across users, apps, and cloud services.",
    //       "Correlate behavioral signals to identify insider misuse and compromised accounts in real time.",
    //       "Automatically respond to data threats with policy enforcement and guided remediation.",
    //     ],
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    // ],
  },
  {
    id: "EndpointIoTSecurity",
    title: "Endpoint/IoT Security",
    icon: EndpointLogo,
    heading: "No blind endpoints. No silent breaches.",
    points: [
      "Classify devices instantly as managed or unmanaged.",
      "Monitor file, clipboard, print, and USB activity with Endpoint DLP.",
      "Hunt threats proactively with integrated EDR/XDR.",
      "Protect connected IoT devices with realtime threat defense.",
    ],
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1771749292/endpoint_s_sgcnqr.png",
    detailHeading: "Endpoint/IoT Security",
    detailIntro: [
      "Endpoints and connected devices are now the most frequent entry point for attackers. With employees working across locations and IoT devices multiplying across networks, organizations struggle to maintain visibility, enforce controls, and protect against modern threats. Unmanaged devices, risky USB activity, and gaps in monitoring leave businesses exposed to data loss, malware, and lateral movement.",
      "Synthera Security delivers unified Endpoint and IoT protection built for today’s distributed enterprise. We instantly classify devices as managed or unmanaged, monitor sensitive activity with Endpoint DLP, and detect threats early through integrated EDR/XDR. IoT devices are secured with real-time threat defense, and every endpoint online, offline, or remote stays protected with consistent Zero Trust controls. With Synthera, your entire device ecosystem becomes visible, governed, and secure.",
    ],
    detailConclusion: <IntegrationsBanner />,
    cards: [
      {
        emoji: "💻",
        title: "Unified Endpoint Protection (XDR)",
        description:
          "Stop ransomware, exploits, and lateral movement with AI-driven detection and rapid response across laptops, servers, and mobile devices.",
        stat: " Block 99% of endpoint breach attempts in real time.",
      },
      {
        emoji: "✅",
        title: " Zero Trust Access for Devices",
        description:
          "Grant access only to trusted, healthy devices with continuous posture checks, identity assurance, and real-time risk evaluation before they reach private apps.",
        stat: "Reduce unauthorized device access by 92%.",
      },
      {
        emoji: "📡",
        title: "IoT & OT Device Discovery",
        description:
          " Automatically discover, classify, and risk-score every managed and unmanaged device — from laptops to IoT and OT and segment exposure to prevent lateral attacks.",
        stat: "Map 100% of connected devices in days, not months.",
      },
      {
        emoji: "☣️",
        title: "Threat Containment & Isolation",
        description:
          "Run web sessions, downloads, and scripts inside a secure isolation environment to block zero-day exploits and malware before they ever touch the endpoint.",
        stat: "Stop 100% of browser delivered exploits.",
      },
    ],
    // extraSections: [
    //   {
    //     title: "Unified Endpoint Protection (XDR)",
    //     description:
    //       "Stop ransomware, exploits, and lateral movement with AI-driven detection and rapid response across laptops, servers, and mobile devices. Correlate endpoint signals, user activity, and network behavior to surface hidden threats, isolate compromised assets, and restore safely with automated remediation.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1764585984/appication_secu_svrprp.webp",
    //   },
    //   {
    //     title: "Zero Trust Access for Devices",
    //     description:
    //       "Grant access only to trusted, healthy devices with continuous posture checks, identity assurance, and real-time risk evaluation before they reach private applications. Enforce least-privilege access, validate device integrity on every request, and automatically block compromised or non-compliant endpoints.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "IoT & OT Device Discovery",
    //     description:
    //       "Automatically discover, classify, and risk-score every managed and unmanaged device—from traditional endpoints to IoT and OT systems—and segment exposure to prevent lateral attacks. Gain full device visibility, identify rogue assets, and prioritize remediation based on real-time risk.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Threat Containment & Isolation",
    //     description:
    //       "Run web sessions, downloads, and active scripts inside a secure isolation environment to stop zero-day exploits and malware before they ever reach the endpoint. Deliver safe rendering to users, block drive-by attacks in real time, and eliminate the browser as an attack surface.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    // ],
  },
  {
    id: "EmailSecurity",
    title: "Email Security",
    icon: EmailLogo,
    heading: "See the email. Stop threats at the inbox",
    points: [
      "Block phishing, spoofing, and BEC with advanced identity and behavior analysis.",
      "Stop malware and ransomware with sandboxing and realtime inspection.",
      "Neutralize malicious links with URL rewriting and time-of-click protection.",
      "Detect compromised accounts with AI-driven internal traffic analysis.",
    ],
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1771749290/email_s_ugdzgs.png",
    detailHeading: "Email Security",
    detailIntro: [
      "Email remains the most exploited channel in the enterprise. Phishing, spoofing, business email compromise, and malware laden messages continue to bypass traditional defenses, targeting users where they are most vulnerable. As attackers leverage AI to craft convincing lures and launch faster, more automated campaigns, organizations need protection that can keep pace.",
      "Synthera Security delivers modern Email Security designed for today’s threat landscape. We block phishing, spoofing, and BEC attempts with identity-aware analysis, stop malware and ransomware through realtime inspection and sandboxing, and neutralize harmful links with URL rewriting and time-of-click protection. Inline DLP prevents sensitive data from leaving your organization, while AI-driven analytics detect compromised accounts from within. With Synthera, every email inbound, outbound, and internal stays secure, so your people can work with confidence.",
    ],
    detailConclusion: <IntegrationsBanner />,
    cards: [
      {
        emoji: "🎣",
        title: "Advanced Threat & Phishing Protection",
        description:
          "Detect and block credential phishing, malware, and targeted attacks using behavioral, content, and URL analysis across cloud email platforms.",
        stat: "Prevent 99% of phishing emails before they hit the inbox.",
      },
      {
        emoji: "🆔",
        title: "Account Takeover & BEC Defense",
        description:
          "Identify compromised accounts and BEC through behavior, login patterns, and communication context.",
        stat: "Reduce successful BEC and account takeover incidents by 90%.",
      },
      {
        emoji: "📧",
        title: "Email Data Loss Prevention (Email DLP)",
        description:
          "Control sensitive data in outbound email with content inspection and context aware policies",
        stat: "Cut email-related data leakage by 80%.",
      },
      {
        emoji: "🏢",
        title: "Email Authentication & Brand Protection",
        description:
          "Enforce SPF, DKIM, and DMARC, detect lookalike senders, and protect customers from brand impersonation.",
        stat: "Reduce domain spoofing and brand impersonation attempts by 95%",
      },
    ],
    // extraSections: [
    //   {
    //     title: "Account Takeover & BEC Defense",
    //     description:
    //       "Analyze user behavior, login patterns, and communication context to detect compromised accounts and Business Email Compromise—even when attacks contain no malicious links or attachments. Identify impersonation attempts, unusual access activity, and payment fraud signals to stop financial loss and account misuse.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1764585984/appication_secu_svrprp.webp",
    //   },
    //   {
    //     title: "Email Data Loss Prevention (Email DLP)",
    //     description:
    //       "Identify and control sensitive information in outbound email with deep content inspection, context-aware policies, and just-in-time user prompts to prevent accidental or malicious data leaks. Enforce compliance rules, block risky sharing, and coach users to make safer decisions.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Email Authentication & Brand Protection",
    //     description:
    //       "Enforce SPF, DKIM, and DMARC across all domains, detect lookalike and spoofed senders, and protect customers and partners from impersonation attacks using your brand identity. Block fraudulent domain use, stop brand abuse, and ensure only legitimate email is trusted.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    // ],
  },
  {
    id: "IdentitySecurity",
    title: "Identity Security",
    icon: IdentityLogo,
    heading: "Verify Every User and protect Every Privilege.",
    points: [
      "Stop credential theft with phishing-resistant MFA and continuous auth.",
      "Prevent privilege escalation via least-privilege and just-in-time PAM.",
      "Detect insiders with AI identity analytics and risk scoring.",
      "Secure API keys/service accounts with Zero Trust monitoring.",
    ],
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1771749760/identity_s_gvglfe.jpg",
    detailHeading: "Identity Security",
    detailIntro: [
      "Identity is now the new perimeter and the most common point of failure. As attackers use phishing, credential theft, and AI-powered impersonation to gain access, even one compromised user can lead to massive breach impact. Complex access rights, orphaned accounts, and unmanaged service identities make it even harder for enterprises to maintain control and stop privilege misuse from within.",
      "Synthera Security delivers Identity Security built for a world where trust must be continuously verified. We stop credential theft with phishing-resistant MFA and continuous authentication, enforce least privilege and just-in-time access to prevent escalation, and automatically remove orphaned accounts before they become risk. AI-driven analytics detect insider threats early, while Zero Trust monitoring protects API keys and service accounts. With Synthera, every identity—human or machine—is validated, governed, and secured end to end.",
    ],
    detailConclusion: <IntegrationsBanner />,
    cards: [
      {
        emoji: "🕵️",
        title: "Identity Threat Detection & Response (ITDR)",
        description:
          " Real-Time Detection of Identity Attacks Identify token theft, session manipulation, lateral identity movement, and MFA fatigue attacks with continuous monitoring and behavioral intelligence.",
        stat: "Detect 90% of identity-based attacks before privilege escalation.",
      },
      {
        emoji: "🔐",
        title: "Adaptive Access & Risk-Based Auth",
        description:
          "Continuous Verification for Every Session Enforce identity trust on every request using behavior analytics, device posture, and dynamic MFA challenges triggered by suspicious activity.",
        stat: "Reduce unauthorized access by 93% with adaptive controls.",
      },
      {
        emoji: "⏱️",
        title: "Just-In-Time Privilege Access",
        description:
          " Eliminate Standing Admin Privileges Provide short-lived privileged access only when needed, with full session recording and automatic revocation to minimize lateral movement risk.",
        stat: "Reduce privileged attack paths by 85%.", // This card had no stat in your data
      },
      {
        emoji: "🤖",
        title: " Machine Identity & Secrets",
        description:
          "Secure API Keys, Tokens & Workload Identity Manage machine identities, rotate secrets automatically, and enforce short-lived credentials for services, workloads, and automation pipelines.",
        stat: "Reduce machine identity compromise risk by 70%.",
      },
    ],
    // extraSections: [
    //   {
    //     title: "Identity Threat Detection & Response (ITDR)",
    //     description:
    //       "Continuously monitor identity activity to detect token theft, session manipulation, and lateral identity movement before attackers gain elevated access. Behavioral intelligence identifies MFA fatigue attacks and abnormal access patterns in real time, enabling rapid response to compromised credentials and identity abuse.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1764585984/appication_secu_svrprp.webp",
    //   },
    //   {
    //     title: "Adaptive Access & Risk-Based Auth",
    //     description:
    //       "Enforce identity trust on every request by combining behavior analytics, device posture, and contextual risk signals. Dynamic MFA challenges trigger only when suspicious activity is detected, allowing legitimate users to move seamlessly while blocking risky access attempts in real time.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Just-In-Time Privilege Access",
    //     description:
    //       "Provide short-lived privileged access only at the moment it’s needed, reducing the attack surface and eliminating standing admin rights. Access is automatically revoked after use, with full session recording for visibility and auditability, minimizing lateral movement risk from compromised identities.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Machine Identity & Secrets",
    //     description:
    //       "Manage machine identities at scale by automatically rotating secrets, certificates, and keys across services, workloads, and automation pipelines. Enforce short-lived credentials and strict access policies to reduce exposure from leaked or outdated secrets and prevent unauthorized machine-to-machine access.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    // ],
  },
  {
    id: "NetworkCloudSecurity",
    title: "Network/Cloud Security",
    icon: NetworkLogo,
    heading: "Segment the network. Verify traffic. Stop breaches.",
    points: [
      "Stop lateral movement with microsegmentation across hybrid clouds.",
      "block threats via next-gen cloud firewalls and workload inspection.",
      "Secure traffic with identity aware SD-WAN for remote users.",
      "Fix misconfigurations using continuous CSPM scanning.",
    ],
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1771749289/network_afq3vc.png",
    detailHeading: "Network & Cloud Security",
    detailIntro: [
      "As businesses expand across hybrid and multi-cloud environments, traditional network models fall short. Workloads move dynamically, remote users connect from everywhere, and misconfigurations open silent pathways for attackers. Lateral movement, cloud drift, and identity blind network controls make it increasingly difficult for enterprises to keep their environments secure and predictable.",
      "Synthera Security delivers modern Network and Cloud Security designed for a Zero Trust world. We stop lateral movement with microsegmentation, block advanced threats through nextgen cloud firewalls and deep workload inspection, and secure traffic for remote users with identity aware SD-WAN. Continuous CSPM scanning finds and fixes misconfigurations before they become vulnerabilities, while Zero Trust policies enforce precision on every connection and workload. With Synthera, your network and cloud environments stay unified, resilient, and protected—no matter how fast they evolve.",
    ],
    detailConclusion: <IntegrationsBanner />,
    cards: [
      {
        emoji: "🧩",
        title: "Microsegmentation to Stop Lateral Movement",
        description:
          "Divide your network and cloud environments into secure microsegments to confine threats, preventing attackers from moving horizontally",
        stat: "Reduce lateral threat exposure by 90%",
      },
      {
        emoji: "🔥",
        title: "Next-Generation Cloud Firewall",
        description:
          "Protect data centers, cloud, and remote locations with cloud-native firewall technology that inspects all non-web traffic without legacy appliance constraints",
        stat: "Achieve 99.9% threat detection across all network layers",
      },
      {
        emoji: "🛣️",
        title: "Identity-Aware SD-WAN",
        description:
          "Deploy software-defined WAN with dynamic, identity-driven routing that adjusts to user context, device posture, and real-time risk—ensuring secure and optimized access for distributed users and workloads",
        stat: "Improve network security posture by 95% while boosting performance and reliability",
      },
      {
        emoji: "☁️",
        title: "Cloud Security Posture Management (CSPM)",
        description:
          "Detect and remediate misconfigurations, enforce compliance, and secure cloud workloads across multiple cloud providers with real-time risk analytics",
        stat: "Eliminate 85% of cloud configuration risks before exploitation",
      },
    ],
    // extraSections: [
    //   {
    //     title: "Microsegmentation to Stop Lateral Movement",
    //     description:
    //       "Divide network and cloud environments into tightly controlled microsegments to confine threats and prevent horizontal movement. Enforce granular, identity-aware policies between workloads, isolate compromised assets instantly, and limit an attacker’s ability to pivot across systems or services.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1764585984/appication_secu_svrprp.webp",
    //   },
    //   {
    //     title: "Next-Generation Cloud Firewall",
    //     description:
    //       "Protect data centers, cloud environments, and remote locations with a cloud-native firewall that inspects all non-web traffic without the constraints of legacy appliances. Enforce granular, identity-aware policies at scale, gain deep visibility into east-west traffic, and block advanced threats across hybrid networks from a unified control plane.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Identity-Aware SD-WAN",
    //     description:
    //       "Deploy software-defined WAN with dynamic, identity-driven routing that adapts to user context, device posture, and real-time risk. Optimize connectivity for distributed users and workloads while enforcing Zero Trust access policies across every branch, edge location, and cloud environment—without relying on static network rules.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    //   {
    //     title: "Cloud Security Posture Management (CSPM)",
    //     description:
    //       "Detect and remediate cloud misconfigurations, enforce compliance standards, and secure workloads across multi-cloud environments using real-time risk analytics. Continuously evaluate cloud resources against best practices, prioritize high-impact issues, and automate fixes to reduce exposure and prevent configuration-driven breaches",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763298807/Data_Security_hzmipo.png",
    //   },
    // ],
  },
];
